<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-vormerkungen">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Vormerkungen" | translate }}</h2>
  </ng-container>
  <cap-standardrecht-table [hasRight]="grundstueckEntry?.permissions?.vormerkungen && ersterfassungUebergeben" [listLoader]="loader">
  </cap-standardrecht-table>
</cap-rubrik>
